"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const objects_1 = require("./objects");
const axios_1 = require("axios");
class Api {
    static async request(config) {
        try {
            const { data } = await (0, axios_1.default)(config);
            return data;
        }
        catch (error) {
            if (error.isAxiosError) {
                const axiosErr = error;
                const errorObject = {
                    error: axiosErr.response?.data?.error,
                    code: axiosErr.code || axiosErr.response?.data?.statusCode,
                    message: axiosErr.response?.data?.message || axiosErr.response?.statusText,
                    config: {
                        baseUrl: axiosErr.config?.baseURL,
                        headers: axiosErr.config?.headers,
                        url: axiosErr.config?.url
                    }
                };
                throw errorObject;
            }
            else {
                throw error;
            }
        }
    }
    static async get(url, params, config) {
        return this.request({
            method: 'GET',
            url,
            params: (0, objects_1.removeEntriesWithUndefinedValue)(params),
            ...config
        });
    }
    static async del(url, params, config) {
        return this.request({
            method: 'DELETE',
            url,
            params,
            ...config
        });
    }
    static async post(url, body, params, config) {
        return this.request({
            method: 'POST',
            url,
            params,
            data: body,
            ...config
        });
    }
    static async patch(url, body, params, config) {
        return this.request({
            method: 'PATCH',
            url,
            params,
            data: body,
            ...config
        });
    }
    static async put(url, body, params, config) {
        return this.request({
            method: 'PUT',
            url,
            params,
            data: body,
            ...config
        });
    }
    static Instance() {
        return axios_1.default;
    }
}
exports.default = Api;
//# sourceMappingURL=api.js.map